<main>
	<app-header [brands]="brands"></app-header>
	<router-outlet></router-outlet>
	<app-footer [brands]="brands"></app-footer>
</main>